function normalizeNumericText(value) {
  return String(value ?? "")
    .trim()
    .replace(/\s/g, "")
    .replace(/[^\d,.-]/g, "");
}

export function sanitizePercentageInput(value) {
  const normalized = String(value ?? "")
    .replace(/\./g, ",")
    .replace(/[^\d,]/g, "");
  const [integerPart = "", ...decimalParts] = normalized.split(",");
  const decimalPart = decimalParts.join("").slice(0, 2);

  if (!normalized.includes(",")) {
    return integerPart;
  }

  return `${integerPart},${decimalPart}`;
}

export function sanitizeWholeNumberInput(value) {
  return String(value ?? "").replace(/\D/g, "");
}

export function parseLocalizedNumber(value) {
  const text = normalizeNumericText(value);
  if (!text || text === "-" || text === "," || text === ".") {
    return 0;
  }

  const negative = text.startsWith("-");
  const unsigned = text.replace(/-/g, "");
  const lastComma = unsigned.lastIndexOf(",");
  const lastDot = unsigned.lastIndexOf(".");
  const decimalIndex = Math.max(lastComma, lastDot);

  let normalized;
  if (lastComma >= 0 && lastDot >= 0) {
    normalized = `${unsigned.slice(0, decimalIndex).replace(/[.,]/g, "")}.${unsigned.slice(decimalIndex + 1).replace(/[.,]/g, "")}`;
  } else if (lastComma >= 0) {
    normalized = `${unsigned.slice(0, lastComma).replace(/,/g, "")}.${unsigned.slice(lastComma + 1).replace(/,/g, "")}`;
  } else if (lastDot >= 0) {
    const dotParts = unsigned.split(".");
    const looksLikeThousands =
      dotParts.length > 2 ||
      (dotParts.length === 2 && dotParts[1].length === 3 && dotParts[0].length <= 3);
    normalized = looksLikeThousands ? dotParts.join("") : unsigned;
  } else {
    normalized = unsigned;
  }

  const parsed = Number(`${negative ? "-" : ""}${normalized}`);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function roundWholeNumber(value) {
  return Math.max(0, Math.round(parseLocalizedNumber(value)));
}

export function roundPercentage(value) {
  const rounded =
    Math.round((parseLocalizedNumber(value) + Number.EPSILON) * 100) / 100;
  return Math.max(0, rounded);
}

export function formatWholeNumberInput(value) {
  return new Intl.NumberFormat("pt-BR", {
    maximumFractionDigits: 0,
  }).format(roundWholeNumber(value));
}

export function formatPercentageInput(value) {
  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(roundPercentage(value));
}
